/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocflowDialogButtonTagEnum } from './docflowDialogButtonTagEnum';


export interface DocflowBlackListDialogRequest { 
    /**
     * Method where throw error
     */
    methodId: number;
    buttonTag: DocflowDialogButtonTagEnum;
    /**
     * Disputable value with field name
     */
    searchFor: string;
    /**
     * Clear field value for DialogResults
     */
    note: string;
    /**
     * Client id
     */
    clientId: number;
}

